<template>
    <div class="">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-copy"></i> 牌照审核 / 厂商业务员</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="厂商业务员牌照审核" name="first">
					<el-form ref="allLicenselyform" :model="allLicenselyform">
						<div class="apply-flex">
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="allLicenselyform.ownerName" style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="allLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(allLicenselyform)" style="width:150px">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="allLicenselyform.cityId" placeholder="请选择市区" style="width:150px">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
						</div>
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch1(allLicenselyform)">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="passApplyfirst({},allLicenselyform)"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="fallbackApplyfirst({},'fallbackform',1)"
						>批量退回</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
						<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
						<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
						<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
						<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
								
                                <el-button
                                    type="text"
                                    icon="el-icon-view"
                                >
								<!-- <router-link :to="'/seelicensecheckjxfirst/'+scope.row.licenseApplyId" style="color: #409EFF;">
								查看
								</router-link> -->
								<router-link :to="'/seelicensecheckjxfirst/'+scope.row.licenseApplyId+'/'+activeName+'/'+query.pageIndex" style="color: #409EFF;">
								查看
								</router-link>
								
								</el-button>
                                <el-button
                                    type="text"
                                    icon=""
                                    @click="passApplyfirst(scope.row,allLicenselyform)"
                                >通过</el-button>
								<el-button
								    type="text"
								    icon=""
								    @click="fallbackApplyfirst(scope.row,'fallbackform',1)"
								>退回</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange1($event,allLicenselyform)"
                        ></el-pagination>
                    </div>
					
					
                </el-tab-pane>
                <el-tab-pane label="厂商业务员车辆变更审核" name="second">
					<el-form ref="secondLicenselyform" :model="secondLicenselyform">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="secondLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="secondLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(secondLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="secondLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch2(secondLicenselyform,2)">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="passApplysec({},secondLicenselyform,2)"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="fallbackApplysec({},'fallbackform',2)"
						>批量退回</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                    	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
                    	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                    	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                    	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                    	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
                               <el-button
                                   type="text"
                                   icon="el-icon-view"
                               >
                               <!-- <router-link :to="'/seelicensecheckjxsec/'+scope.row.mechanicsTransactionApplyId" style="color: #409EFF;">
                               查看
                               </router-link> -->
							   
							   <router-link :to="'/seelicensecheckjxsec/'+scope.row.mechanicsTransactionApplyId+'/'+activeName/+'/'+query.pageIndex" style="color: #409EFF;">
							   查看
							   </router-link>
							   
                               </el-button>
                                <el-button
                                    type="text"
                                    icon=""
                                    @click="passApplysec(scope.row,secondLicenselyform,2)"
                                >通过</el-button>
								<el-button
								    type="text"
								    icon=""
								    @click="fallbackApplysec(scope.row,'fallbackform',2)"
								>退回</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange2($event,secondLicenselyform,2)"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="厂商业务员车主变更审核" name="third">
					<el-form ref="thirdLicenselyform" :model="thirdLicenselyform">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="thirdLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="thirdLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(thirdLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="thirdLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch2(thirdLicenselyform,1)">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="passApplysec({},thirdLicenselyform,1)"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="fallbackApplysec({},'fallbackform',3)"
						>批量退回</el-button>
					</p>
					
                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                    	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
                    	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                    	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                    	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                    	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                    	
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-view"
                                >
                               <!-- <router-link :to="'/seelicensecheckjxsec/'+scope.row.mechanicsTransactionApplyId" style="color: #409EFF;">
                                查看
                                </router-link> -->
								<router-link :to="'/seelicensecheckjxsec/'+scope.row.mechanicsTransactionApplyId+'/'+activeName/+'/'+query.pageIndex" style="color: #409EFF;">
								查看
								</router-link>
								
                                </el-button>
                                <el-button
                                    type="text"
                                    icon=""
                                    @click="passApplysec(scope.row,thirdLicenselyform,1)"
                                >通过</el-button>
								<el-button
								    type="text"
								    icon=""
								    @click="fallbackApplysec(scope.row,'fallbackform',3)"
								>退回</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange2($event,thirdLicenselyform,1)"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
				<el-tab-pane label="厂商业务员牌照修改审核" name="fourth">
					<el-form ref="fourthLicenselyform" :model="fourthLicenselyform">
						<div class="apply-flex"> 
							<p>
								<el-form-item label="车主姓名"  prop='ownerName'>
									<el-input v-model="fourthLicenselyform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="fourthLicenselyform.provinceId" placeholder="请选择省份" @change="provinceChange(fourthLicenselyform)">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="fourthLicenselyform.cityId" placeholder="请选择市区">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
						</div>
						
						
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch3()">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="passApplythird({})"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-delete"
							class="handle-del  "
							@click="fallbackApplythird({},'fallbackform',4)"
						>批量退回</el-button>
					</p>
					
				    <el-table
				        :data="allLicenselyTableData"
				        border
				        class="table"
				        ref="multipleTable"
				        header-cell-class-name="table-header"
				        @selection-change="handleSelectionChange"
				    >
				        <el-table-column type="selection" width="55" align="center"></el-table-column>
				        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
				        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
				    	<el-table-column prop="machineryType" label="机械类型" align="center"></el-table-column>
				    	<el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
				    	<el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
				    	<el-table-column prop="fuelType" label="燃油类型"></el-table-column>
				    	<el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
				    	
				        <el-table-column label="操作" width="180" align="center">
				            <template slot-scope="scope">
				                <el-button
				                    type="text"
				                    icon="el-icon-view"
				                >
				             <!--   <router-link :to="'/seelicensecheckjxthird/'+scope.row.licenseApplyId" style="color: #409EFF;">
				                查看
				                </router-link> -->
								
								<router-link :to="'/seelicensecheckjxthird/'+scope.row.licenseApplyId+'/'+activeName/+'/'+query.pageIndex" style="color: #409EFF;">
								查看
								</router-link>
				                </el-button>
				                <el-button
				                    type="text"
				                    icon=""
				                    @click="passApplythird(scope.row)"
				                >通过</el-button>
								<el-button
								    type="text"
								    icon=""
								    @click="fallbackApplythird(scope.row,'fallbackform',4)"
								>退回</el-button>
				            </template>
				        </el-table-column>
				    </el-table>
				    <div class="pagination">
				        <el-pagination
				            background
				            layout="total, prev, pager, next"
				            :current-page="query.pageIndex"
				            :page-size="query.pageSize"
				            :total="pageTotal"
				            @current-change="handlePageChange3"
				        ></el-pagination>
				    </div>
				</el-tab-pane>
				
				
            </el-tabs>
        </div>
    
		<el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
		    <el-form ref="fallbackform" :model="fallbackform">
		        <el-form-item label="" prop="auditReason">
					<el-input type="textarea" v-model="fallbackform.auditReason" placeholder="请输入回退原因" class="resizeNone">
						
					</el-input>
		        </el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button @click="fallbackVisible = false">取 消</el-button>
				<!-- 1牌照审核  2 车辆变更  3 车主变更  4牌照修改审核-->
				<el-button type="primary" v-if="btntagVisible==1" @click="savefallbackfirst(allLicenselyform)">确 定</el-button>
				<el-button type="primary" v-if="btntagVisible==2" @click="savefallbacksec(secondLicenselyform,2)">确 定</el-button>
				<el-button type="primary" v-if="btntagVisible==3" @click="savefallbacksec(thirdLicenselyform,1)">确 定</el-button>
				<el-button type="primary" v-if="btntagVisible==4" @click="savefallbackthird()">确 定</el-button>
				
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {listProvinces,listCitysByProvinceId,listLicenseApplyExamines,listMechanicsTransactionApplyExamines,listLicenseApplyUpdateExamines,examineLicenseApply,examineMechanicsTransactionApply} from '../api/index';
    export default {
        name: 'licenseapplys',
        data() {
            return {
                activeName: 'first',
				provinceOptions:[],  //省列表
				citysOptions:[],   //市列表
				allLicenselyform:{
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				},  //所有的搜索表单
				secondLicenselyform:{
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				},
				thirdLicenselyform:{
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				},
				fourthLicenselyform:{
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				},
				
				query: {
				    pageIndex: 1,
				    pageSize: 10
				},   //分页
				allLicenselyTableData: [],
				multipleSelection: [],
				pageTotal: 0,
				
				
				
				fallbackVisible:false,
				fallbackform:{
					auditReason:''
				},
				fallbackArr:[],
				btntagVisible:''
               
            }
        },
		created() {
			this.activeName = this.$route.params.activeName
			this.query.pageIndex = this.$route.params.pageIndex
			var that =  this;
			// 省
			listProvinces({
			}).then(res => {
			    // 获取数据成功后的其他操作
				that.provinceOptions = res.data;
			});
			// 牌照审核
		    this.getlistLicenseApplyExamines(this.allLicenselyform);  //初始化form为全部allLicenselyform
		},
        methods: {
			// 省改变请求市
			provinceChange(Licenselyform){
				Licenselyform.cityId = '';
				listCitysByProvinceId({
					provinceId:Licenselyform.provinceId
				}).then(res => {
				    // 获取数据成功后的其他操作
					this.citysOptions = res.data;
				});
			},
			
			// 牌照审核
			getlistLicenseApplyExamines(form) {
				var LicenseApplyobj = {};
				LicenseApplyobj = form;
				LicenseApplyobj.organizationKind = 4;
				LicenseApplyobj.current = this.query.pageIndex;
				LicenseApplyobj.size = this.query.pageSize;
			    listLicenseApplyExamines(LicenseApplyobj).then(res => {
			        // 获取数据成功后的其他操作
			    	this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
			// 车辆变更+车主变更tag:1(车主变更) 2(车辆变更)
			getlistMechanicsTransactionApplyExamines(form,tag) {
				var LicenseApplyobj = {};
				LicenseApplyobj = form;
				LicenseApplyobj.organizationKind = 4;
				LicenseApplyobj.isRetainLicenseNumber = tag;
				LicenseApplyobj.current = this.query.pageIndex;
				LicenseApplyobj.size = this.query.pageSize;
			    listMechanicsTransactionApplyExamines(LicenseApplyobj).then(res => {
			        // 获取数据成功后的其他操作
			    	this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
			//牌照修改审核
			getlistLicenseApplyUpdateExamines() {
				this.fourthLicenselyform.organizationKind = 4;
				this.fourthLicenselyform.current =  this.query.pageIndex;
				this.fourthLicenselyform.size = this.query.pageSize;
			    listLicenseApplyUpdateExamines(this.fourthLicenselyform).then(res => {
			        // 获取数据成功后的其他操作
			    	this.allLicenselyTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
			// 切换
            handleClick(tab, event) {
				this.allLicenselyform = {
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				}; 
				this.secondLicenselyform = {
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				};
				this.thirdLicenselyform={
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				};
				this.fourthLicenselyform={
					ownerName:'',//车主姓名
					provinceId:'',
					cityId:'',
				};
				this.query.pageIndex = 1;
				this.allLicenselyTableData = [];
				var organizationKind = '';
				if(tab.name == 'first'){
					this.getlistLicenseApplyExamines(this.allLicenselyform); 
				}else if(tab.name == 'second'){
					this.getlistMechanicsTransactionApplyExamines(this.secondLicenselyform,2)
				}else if(tab.name == 'third'){
					this.getlistMechanicsTransactionApplyExamines(this.thirdLicenselyform,1)
				}else if(tab.name == 'fourth'){
					this.getlistLicenseApplyUpdateExamines();
				}
				// tag:1(车主变更) 2(车辆变更)
            },
			
			// 触发搜索按钮
			handleSearch1(form) {
				this.query.pageIndex =  1;
				this.getlistLicenseApplyExamines(form);
			},
			handleSearch2(form,tag) {
				this.query.pageIndex =  1;
				this.getlistMechanicsTransactionApplyExamines(form,tag);
			},
			
			handleSearch3() {
				this.query.pageIndex =  1;
				this.getlistLicenseApplyUpdateExamines();
			},
			
			// 牌照审核通过
			passApplyfirst(row,form){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var licenseApplyIdsArr = [];  
				if(row.licenseApplyId){
					licenseApplyIdsArr.push(row.licenseApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							licenseApplyIdsArr.push(that.multipleSelection[i].licenseApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要通过的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				
				this.$confirm('确定要通过吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineLicenseApply({
				        	isPass:1,                    
				        	licenseApplyIds: licenseApplyIdsArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							 this.query.pageIndex = 1;
				        	 this.getlistLicenseApplyExamines(form);
							 
							 listTaskRemindNum({}).then(ress => {
							 	   this.$store.state.totalNum =  ress.data.totalNum;
							 });
				        });
				}).catch(() => {});
				
			  },
			
			// 删除操作
			
			// 回退弹框
			fallbackApplyfirst(row,formName,btntagVisible){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var licenseApplyIdsArr = [];  
				if(row.licenseApplyId){
					licenseApplyIdsArr.push(row.licenseApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							licenseApplyIdsArr.push(that.multipleSelection[i].licenseApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要回退的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				this.fallbackArr = licenseApplyIdsArr;
				this.btntagVisible = btntagVisible;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				})
				
				
			},
			
			//牌照审核退回
			savefallbackfirst(form){
				this.$confirm('确定要退回吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineLicenseApply({
							auditReason:this.fallbackform.auditReason,
				        	isPass:2,                    
				        	licenseApplyIds: this.fallbackArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.query.pageIndex = 1;
				        	this.getlistLicenseApplyExamines(form);
							this.fallbackVisible = false;
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
				        });
				}).catch(() => {});
			},
			
			// 车辆变更+车主变更tag:1(车主变更) 2(车辆变更)
			passApplysec(row,form,tag){
			  	var that = this;
			  	var mechanicsTransactionApplyIdArr = [];  
			  	if(row.mechanicsTransactionApplyId){
			  		mechanicsTransactionApplyIdArr.push(row.mechanicsTransactionApplyId);
			  	}else{
			  		if(that.multipleSelection.length>0){
			  			for(var i in that.multipleSelection){
			  				mechanicsTransactionApplyIdArr.push(that.multipleSelection[i].mechanicsTransactionApplyId);
			  			}
			  		}else{
			  			this.$message({
			  			  message: '没有选择要通过的选项哦',
			  			  center: true
			  			});
			  			return false;
			  		}
			  	}
			  	
			  	this.$confirm('确定要通过吗？', '提示', {
			  	    type: 'warning'
			  	}).then(() => {
			  	        examineMechanicsTransactionApply({
			  	        	isPass:1,                    
			  	        	mechanicsTransactionApplyIds: mechanicsTransactionApplyIdArr              
			  	        }).then(res => {
			  	        	// 获取数据成功后的其他操作
			  				this.$message({
			  				  message: res.message,
			  				  type: 'success'
			  				});
			  				 this.query.pageIndex = 1;
			  	        	 this.getlistMechanicsTransactionApplyExamines(form,tag);
							 listTaskRemindNum({}).then(ress => {
							 	   this.$store.state.totalNum =  ress.data.totalNum;
							 });
			  	        });
			  	}).catch(() => {});
			  	
			    },
			
			// 车辆变更+车主变更tag:1(车主变更) 2(车辆变更)   退回
			fallbackApplysec(row,formName,btntagVisible){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var mechanicsTransactionApplyIdArr = [];  
				if(row.mechanicsTransactionApplyId){
					mechanicsTransactionApplyIdArr.push(row.mechanicsTransactionApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							mechanicsTransactionApplyIdArr.push(that.multipleSelection[i].mechanicsTransactionApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要回退的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				this.fallbackArr = mechanicsTransactionApplyIdArr;
				this.btntagVisible = btntagVisible;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				})
				
				
			},
			
			//换证退回
			savefallbacksec(form,tag){
				this.$confirm('确定要退回吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineMechanicsTransactionApply({
							auditReason:this.fallbackform.auditReason,
				        	isPass:2,                    
				        	mechanicsTransactionApplyIds: this.fallbackArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.query.pageIndex = 1;
				        	this.getlistMechanicsTransactionApplyExamines(form,tag);
							this.fallbackVisible = false;
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
				        });
				}).catch(() => {});
			},
			
			
			// 修改通过
			
			passApplythird(row){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var licenseApplyIdsArr = [];  
				if(row.licenseApplyId){
					licenseApplyIdsArr.push(row.licenseApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							licenseApplyIdsArr.push(that.multipleSelection[i].licenseApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要通过的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				
				this.$confirm('确定要通过吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineLicenseApply({
				        	isPass:1,                    
				        	licenseApplyIds: licenseApplyIdsArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							 this.query.pageIndex = 1;
				        	 this.getlistLicenseApplyUpdateExamines();
							 listTaskRemindNum({}).then(ress => {
							 	   this.$store.state.totalNum =  ress.data.totalNum;
							 });
				        });
				}).catch(() => {});
				
			  },
			
			// 删除操作
			
			// 回退弹框
			fallbackApplythird(row,formName,btntagVisible){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var licenseApplyIdsArr = [];  
				if(row.licenseApplyId){
					licenseApplyIdsArr.push(row.licenseApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							licenseApplyIdsArr.push(that.multipleSelection[i].licenseApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要回退的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				this.fallbackArr = licenseApplyIdsArr;
				this.btntagVisible = btntagVisible;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				})
				
				
			},
			
			//牌照修改审核退回
			savefallbackthird(){
				this.$confirm('确定要退回吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineLicenseApply({
							auditReason:this.fallbackform.auditReason,
				        	isPass:2,                    
				        	licenseApplyIds: this.fallbackArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.query.pageIndex = 1;
				        	this.getlistLicenseApplyUpdateExamines();
							this.fallbackVisible = false;
							listTaskRemindNum({}).then(ress => {
								   this.$store.state.totalNum =  ress.data.totalNum;
							});
				        });
				}).catch(() => {});
			},
			
			
			
			
			// 多选操作
			handleSelectionChange(val) {
			    this.multipleSelection = val;
			},
			
			// 分页导航
			// 牌照
			handlePageChange1(val,form) {
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistLicenseApplyExamines(form);
			},
			// 车辆变更+车主变更
			handlePageChange2(val,form,tag) {
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistMechanicsTransactionApplyExamines(form,tag);
			},
			handlePageChange3(val) {
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistLicenseApplyUpdateExamines();
			}
        },
        computed: {
            
        }
    }

</script>


<style scoped>
	
	.apply-flex{
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
	}
	.apply-flex p{
		width: 25%;
		margin-right: 20px;
	}
	
	.apply-flex p.apply-flexarea .el-form-item{
		margin-right: 10px;
	}
	.apply-flex p.apply-flexarea{
		width: 40%;
		display: flex;
		display: -webkit-flex;
	}
	.apply-flex .el-form-item{
		display: flex;
		display: -webkit-flex;
	}

	
	.flex-btn {
		margin-bottom: 20px;
		text-align: right;
		border-top: 1px solid #ddd;
		padding-top: 10px;
	}


.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>


<style>
	.apply-flex p .el-form-item__label{
		width: 80px;
	}
</style>